/* eslint-disable prettier/prettier */
/** @jsxImportSource @emotion/react */
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import axios from 'axios';
import getAppState from 'app-state';
import {
  addItem,
  setLoading,
} from 'cart-ui-react/src/autoshipState/autoshipSlice';
import Xbutton from '../../Xbutton';
import SearchIcon from '../../SearchIcon';
import ClickAwayListener from '../../../../components/ClickAwayListener';
import { format } from '../../Utils/currencyFormatter';
import t from '@rcm/i18n-client';

const blockedItemCodes = ['RENEWAL', '2010', 'DBPWS', 'PCRENEW', 'MOBAPP'];

const SearchBar = ({ mobile = false }) => {
  const dispatch = useDispatch();
  const [matches, setMatches] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [allStoreItems, setAllStoreItems]: any[] = useState([]);
  const locale = getAppState('rcmi18n');

  // TODO sku
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    axios
      .get('/api/v2/get-items/' + locale['defaultLocale'])
      .then((response) => {
        const tempItems = response.data?.reduce((acc, cur) => {
          if (blockedItemCodes.includes(cur.itemCode)) return acc;
          const exists = acc.some((item) => item.name === cur.name);
          if (!exists) return [...acc, cur];
          return acc;
        }, []);
        setAllStoreItems(tempItems);
      });
  }, []);

  const clearSearch = () => {
    setSearchTerm('');
    setMatches([]);
  };

  const handleSelect = (itemCode) => {
    dispatch(setLoading(true));
    const rawItem = allStoreItems?.find((i) => i.itemCode === itemCode);
    const item = {
      product_id: rawItem.product_id,
      skuId: rawItem.skuId,
      price: rawItem.price,
      bv: rawItem.data.bv,
      pv: rawItem.data.pv,
      name: rawItem.name,
      itemCode: rawItem.itemCode,
      detailPage: rawItem.detailPage,
      imgUrl: rawItem.imgUrl,
      quantity: 1,
    };
    dispatch(addItem(item));
    // dispatch(temp(item));
    clearSearch();
  };
  const handleSearchItems = (e) => {
    const matchList = [];
    setSearchTerm(e.target.value);

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < allStoreItems.length; i++) {
      const itemCode = String(allStoreItems[i].itemCode);
      let itemName = allStoreItems[i].name
        .toLowerCase()
        .replace(/([^a-z])+/g, '');
      itemName = itemName.replace(/\s/g, '');
      if (
        itemName.includes(e.target.value.toLowerCase().replace(/\s/g, '')) ||
        itemCode.includes(e.target.value)
      ) {
        matchList.push(allStoreItems[i]);
      }
      setMatches(matchList);
    }
  };

  useEffect(() => {
    if (!allStoreItems.length) return;
    // forces page to preload all images for items
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < allStoreItems.length; i++) {
      new Image().src = allStoreItems[i].imgUrl;
    }
  }, [allStoreItems]);

  const allMatches = () => {
    return matches.map((i, index) => (
      <div
        key={`${i.itemCode} | ${i.name}`}
        onClick={() => handleSelect(i.itemCode)}
        css={{
          cursor: 'pointer',
          display: 'flex',
          fontSize: '14px',
          lineHeight: '20px',
          padding: '4px 8px',
          backgroundColor: index % 2 == 1 ? '#EEE' : 'white',
          ['&:hover']: { backgroundColor: '#ceeefa' },
        }}
      >
        <div css={{ width: '30px', height: '45px', marginRight: '12px' }}>
          <img css={{ maxWidth: '30px', maxHeight: '45px' }} src={i.imgUrl} />
        </div>
        <div css={{}}>
          <div>{i.name}</div>
          <div>{format(i.price)}</div>
        </div>
      </div>
    ));
  };
  return (
    <ClickAwayListener onClickOutside={() => setMatches([])}>
      <div
        css={{
          border: '1px solid black',
          paddingBottom: '1.5px',
          height: '35px',
          display: 'flex',
          flexWrap: 'nowrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderRadius: '4px',
          padding: '1px 6px 1px 8px',
        }}
        onClick={() =>
          searchTerm.length ? handleSearchItems : setMatches(allStoreItems)
        }
      >
        <SearchIcon />
        <input
          css={{
            width: '100%',
            height: '33px',
            boxShadow: 'none !important',
            border: 'none !important',
            flexGrow: 4,
          }}
          style={{ fontSize: '16px' }}
          id='item-search-mocha'
          type='text'
          placeholder={t('add an item') + '...'}
          onChange={handleSearchItems}
          value={searchTerm}
        />
        {searchTerm.length ? (
          <Xbutton
            disableSpin
            sx={{
              width: '20px',
              height: '20px',
            }}
            onClick={clearSearch}
          />
        ) : null}
      </div>

      {matches.length ? (
        <div
          css={{
            maxWidth: mobile ? '76%' : '95%',
            maxHeight: '280px',
            overflow: 'scroll',
            position: 'absolute',
            boxShadow: '3px 4px 6px rgb(80 80 80 / 20%)',
            background: 'white',
            padding: '0px',
            border: 'solid 1px #CCC',
            zIndex: 50,
            width: '-webkit-fill-available',
          }}
        >
          {allMatches()}
        </div>
      ) : null}
    </ClickAwayListener>
  );
};

export default SearchBar;
